
















import {Component, Prop, Vue} from 'vue-property-decorator'
import {CategoryCollection} from '@/model/collection/CategoryCollection'
import {FilterCategorySchema} from '@/schema/resource/Category/FilterCategorySchema'

@Component
export default class FilterCategory extends Vue {
  @Prop({type: Object, required: true}) collection!: CategoryCollection

  schema = new FilterCategorySchema()

  async created() {
    await this.populateFilterOptions()
  }

  async populateFilterOptions() {
    this.collection.resource = this.schema

    const promises: Array<Promise<any>> = []

    await this.$await.run('softQuery', () => Promise.all(promises))
  }

  async doFilter() {
    this.$emit('submit')
    await this.$await.run('softQuery', () => this.collection.queryAsPage())
  }
}
